import { useSelector, useDispatch } from "react-redux";
import Drawer from "@mui/material/Drawer";
import { useLocation } from "react-router";

import { RootState } from "@/store/store";
import AppointmentsDrayewExistEntity from "../AppointmentsDrawerExistEntity/AppointmentsDrayewExistEntity";
import AppointmentsDrayewNewEntity from "../AppointmentsDrawerNewEntity/AppointmentsDrayewNewEntity";
import { setPatientDoctorSelectorInDrawer } from "@/store/ui/ui";
import Title from "@/shared/components/Title/Title";
import CloseCross from "@/shared/components/CloseCross/CloseCross";

import {
    ISearchDrawerProps,
    IToggleEntityExist,
} from "@//shared/interfaces/ui";

import "./AppointmentsSearchDrawer.scss";

export default function AppointmentsSearchDrayer({
    toggleDrawer,
    open,
    toggleExistUser,
    isExistuser,
    isEditEntity,
}: ISearchDrawerProps & IToggleEntityExist) {
    const myLocation = useLocation();
    const dispatch = useDispatch();
    const patientDoctorSelectorInDrawer = useSelector(
        (state: RootState) => state.ui.patientDoctorSelectorInDrawer,
    );
    const isLocalLoading = useSelector(
        (state: RootState) => state.ui.isLocalLoading,
    );
    const isPatientsPage = myLocation.pathname.includes("patients");
    const isDoctor = patientDoctorSelectorInDrawer === "doctor";

    return (
        <Drawer
            open={open}
            onClose={() => {
                if (!isLocalLoading) {
                    toggleDrawer(false);
                    if (isDoctor) {
                        dispatch(setPatientDoctorSelectorInDrawer("patient"));
                    }
                }
            }}
            anchor='right'
        >
            <div className='drawer_container'>
                <div className='drawer_title_container drawer_app_item'>
                    <Title
                        tag='h2'
                        text={`${
                            isEditEntity
                                ? "Редагувати"
                                : isPatientsPage
                                ? "Додати"
                                : "Обрати"
                        } ${
                            patientDoctorSelectorInDrawer === "patient"
                                ? "пацієнта"
                                : "лікаря"
                        } `}
                    />
                    <CloseCross onClick={() => toggleDrawer(false)} />
                </div>
                {isPatientsPage
                    ? null
                    : !isEditEntity &&
                      !isDoctor && (
                          <div className='drawer_isnewpatient_selector drawer_app_item'>
                              <div
                                  onClick={() => toggleExistUser?.(true)}
                                  className={`drawer_patients_selector ${
                                      isExistuser ? "" : "unactive_selector"
                                  }`}
                              >
                                  Постійний
                              </div>
                              <div
                                  onClick={() => toggleExistUser?.(false)}
                                  className={`drawer_patients_selector ${
                                      isExistuser ? "unactive_selector" : ""
                                  }`}
                              >
                                  Новий
                              </div>
                          </div>
                      )}

                {isExistuser ? (
                    <AppointmentsDrayewExistEntity
                        toggleDrawer={toggleDrawer}
                    />
                ) : (
                    <AppointmentsDrayewNewEntity
                        toggleDrawer={toggleDrawer}
                        isEditEntity={isEditEntity}
                        open={open}
                    />
                )}
            </div>
        </Drawer>
    );
}
